<div class="toggle" (click)="onClick($event)" #toggle>
	<input class="toggle-input" type="checkbox" />
	<button class="toggle-btn" role="checkbox" [ngClass]="{'toggle-btn-on': on, 'toggle-btn-off': !on}" [attr.aria-checked]="on"
					[attr.aria-label]="ariaLabel"></button>
</div>